var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Button, Image, PDFViewer } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import './file-preview.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import FilePreviewApi from './file-preview-api';
let FilePreview = class FilePreview extends Component {
    constructor() {
        super(...arguments);
        this.onClickButtonDownload = () => {
            const { data } = this.props;
            const href = `data:${data.mimeType};base64,${data.content}`;
            const link = document.createElement('a');
            link.href = href;
            link.download = data.fileName;
            link.click();
        };
    }
    isNoPreview() {
        const { data } = this.props;
        return !data.preview;
    }
    isText() {
        const { data } = this.props;
        return data.mimeType.startsWith('text/');
    }
    isImage() {
        const { data } = this.props;
        return data.mimeType.startsWith('image/');
    }
    isPDF() {
        const { data } = this.props;
        return data.mimeType.startsWith('application/pdf');
    }
    render() {
        const { data, noPreviewMessage, downloadButtonText } = this.props;
        if (!data) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: "c-file-preview" },
            this.isText() &&
                React.createElement("div", { className: "c-file-preview-content" }, data.content),
            this.isImage() &&
                React.createElement("div", { className: "c-file-preview-content" },
                    React.createElement(Image, { src: `data:${data.mimeType};base64,${data.content}`, alt: "Preview" })),
            this.isPDF() &&
                React.createElement("div", { className: "c-file-preview-content" },
                    React.createElement(PDFViewer, { uuid: generateUUID(), src: `data:${data.mimeType};base64,${data.content}` })),
            this.isNoPreview() &&
                React.createElement("div", { className: "c-file-no-preview" },
                    React.createElement("h2", null, MessageService.translate(noPreviewMessage)),
                    React.createElement(Button, { className: "c-button-download", value: MessageService.translate(downloadButtonText), onClick: this.onClickButtonDownload }))));
    }
};
FilePreview = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: FilePreviewApi })
], FilePreview);
export default FilePreview;
//# sourceMappingURL=file-preview.js.map